module.exports = __webpack_public_path__ + "static/img/visualization_polar.57d3af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visualization_polar.png
// module id = AQUM
// module chunks = 94